import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=ba8f582e&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f582e",
  null
  
)

export default component.exports